import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from '@material-ui/core';
import React, { FC } from 'react';

interface Props {
  isOpen: boolean;
  title?: string;
  subTitle?: string;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  disableBackDropClick?: boolean;
  onHandleConfirmAction: () => void;
  onHandleClose: () => void;
}

const SimpleDecisionDialog: FC<Props> = ({
  isOpen,
  title,
  subTitle,
  disableBackDropClick = false,
  confirmButtonLabel = 'Confirm',
  cancelButtonLabel = 'Cancel',
  onHandleConfirmAction,
  onHandleClose
}) => {
  const onHandleConfirm = () => {
    onHandleConfirmAction();
  };

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClose={onHandleClose}
      fullWidth
      maxWidth="sm"
      disableBackdropClick={disableBackDropClick} // intended and working even if deprecated
    >
      <DialogTitle id="alert-dialog-title">
        <Typography style={{ fontWeight: 700, fontSize: '20px' }}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {subTitle && (
          <DialogContentText id="alert-dialog-description">
            <Typography style={{ fontSize: '16px' }}>{subTitle}</Typography>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Button onClick={onHandleClose} color="secondary">
          {cancelButtonLabel}
        </Button>
        <Button onClick={onHandleConfirm} color="primary" autoFocus>
          {confirmButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SimpleDecisionDialog;
